import {
    getBindingDriftReport,
    listBindingDriftReports,
} from './queries';

import {GraphQLQuery} from '@aws-amplify/api';
import {BindingDriftReport} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";

export type ListBindingDriftReports = {
    listBindingDriftReports: { items: BindingDriftReport[], nextToken: string }
}

export type GetBindingDriftReport = {
    getBindingDriftReport: BindingDriftReport
}

const client = billingApiClient;

// FNP-585: read-only module. No create/update/delete — the binding-drift sweep
// (FNP-502) owns the lifecycle. listBindingDriftReports is the single list query
// (recordType-runStartedAt GSI, newest-first); there are no filter variants.
export const fetchRecords = async (query: ListRecordsQuery) => {
    const {limit, nextToken} = query;

    const response = await client.graphql<GraphQLQuery<ListBindingDriftReports>>({
        query: listBindingDriftReports,
        variables: {
            limit,
            nextToken,
        },
    });
    return {
        // Guard against a GraphQL-level error (response.data undefined), so the hook
        // always receives a real array, never an undefined item (the FNP-539 backstop).
        items: response.data?.listBindingDriftReports.items ?? [],
        nextToken: response.data?.listBindingDriftReports.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBindingDriftReport>>({
        query: getBindingDriftReport,
        variables: {id: id},
    });
    return response.data?.getBindingDriftReport;
};
